import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../context/auth/auth-context'
import axios from 'axios'
import { Box, Chip, IconButton, Modal, Stack, Typography, useTheme } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { isValidObjectString } from '../../utils/string-utils'
import { formatToLocalMilliTimestampFromUTCNumber } from '../../utils/time-utils'

interface PlainModalProps {
  open: boolean
  onClose: () => void
  title: string
  dataUrl: string | null
}

const PlainModal: React.FC<PlainModalProps> = (
  { open, onClose, title, dataUrl },
) => {
  const theme = useTheme()
  const [description, setDescription] = useState<string>('')
  const [retrievalTimestamp, setRetrievalTimestamp] = useState<number>(0)

  const { isAuthorized, accessToken } = useContext(AuthContext)

  useEffect(() => {
    if (!open || !isAuthorized) {
      return
    }

    if (dataUrl != null && dataUrl.length !== 0) {
      console.debug(`[Modal] Fetching data for ${title}`)
      axios
        .get(dataUrl, { headers: { Authorization: `Bearer ${accessToken}` } })
        .then(response => {
          setDescription(response.data)
          setRetrievalTimestamp(Date.now())
        })
        .catch(reason => {
          console.error(reason)
          setDescription('')
          setRetrievalTimestamp(-1)
        })
    }
  }, [open, isAuthorized, dataUrl])

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute' as 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: '1200px',
          height: '80%',
          maxHeight: '1000px',
          overflowY: 'scroll',
          bgcolor: 'background.paper',
          border: `1px solid ${theme.palette.primary.main}`,
          boxShadow: 24,
          p: 4,
          color: 'white',
        }}
      >
        <Stack direction='row' alignItems='center' gap={1}>
          <Typography id='modal-modal-title' fontWeight='bold' variant='h5' component='h1'>
            {title}
          </Typography>
          <Chip
            label={formatToLocalMilliTimestampFromUTCNumber(retrievalTimestamp)}
            size='small'
          />
          <Box marginX='auto'></Box>
          <IconButton color='error' onClick={onClose}>
            <CloseIcon/>
          </IconButton>
        </Stack>

        <Typography id='modal-modal-description' sx={{ mt: 2, mb: 2, whiteSpace: 'pre-wrap' }}>
          {isValidObjectString(description) ? JSON.stringify(description, null, 2) : description}
        </Typography>
      </Box>
    </Modal>
  )
}

export default PlainModal
